"use client";
import React, { useEffect, useState } from "react";

import "./boxstyle.css";
import VestWorks from "./VestWorks";
import { RoadmapSection } from "./RoadmapSection";
import  {TokenomicsSection}  from "./TokenomicsSection";
import  Footer  from "./Footer";
import  {ApyReferralHighlights}  from "./ApyReferralHighlights";
import { VuesaxBulkShieldTick } from "./ui/VuesaxBulkShieldTick";
import { FAQSection } from "./FAQSection";
import { StakeCalculte } from "./StakeCalculte";
import  {VestingTable}  from "./VestingTable";
import  {VestOverview}  from "./VestOverview";

import ClipLoader from "react-spinners/ClipLoader";

import HowToBuySection from "./HowToBuySection";

import toast from "react-hot-toast";
import { isAddress } from "ethers"; // v6+
import { ethers } from "ethers";
import { feeds, NETWORKS, aggregatorV3ABI } from "../contracts/aggregatorV3ABI";
import useContract from "../hooks/useContract";
import {
  useAppKitAccount,
  useAppKitNetwork,
  useDisconnect,
  useAppKit
} from "@reown/appkit/react";
import { mainnet, bsc, base, polygon } from "@reown/appkit/networks";

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

const VestingPage = () => {  const highlights = [
    {
      title: "14% APY",
      subtitle: "Compounded rewards on $BABYU",
    },
    {
      title: "2% Referral Bonus",
      subtitle: "Invite and earn more",
    },
    {
      title: "7-Day Unstake",
      subtitle: "Stake anytime wait 7 days unstake",
    },
  ];

  const [error, setError] = useState(null); // State for any errors

 const [color, setColor] = useState("#ffffff");

  const { open } = useAppKit();
  const { isConnected, address } = useAppKitAccount();




    const { getVestedAllocation ,getVestedClaimable , getVestedClaimed ,claimvestTokens ,myTokenBalance ,maxBalances ,manualvestTokens ,saveVestingData} = useContract();




const [vestLoading, setVestLoading] = useState(false);
const [vestInput, setVestInput] = useState("");



  
  const [totalVestedTokens, setTotalVestedTokens] = useState(null);
  const [totalVestedClaimedTokens, setTotalVestedClaimedTokens] = useState(null);
  const [totalVestedClaimableTokens, setTotalVestedClaimableTokens] = useState(null);
  



  const handleVestNow = async () => {

};




  useEffect(() => {
    if (!address || !isConnected) return;
  
    const fetchVestingData = async () => {
      try {
        const allocation = await getVestedAllocation();
        setTotalVestedTokens(parseFloat(allocation || "0").toFixed(2));
  
        const claimed = await getVestedClaimed();
        setTotalVestedClaimedTokens(parseFloat(claimed || "0").toFixed(2));
  
        const claimable = await getVestedClaimable();
        setTotalVestedClaimableTokens(parseFloat(claimable || "0").toFixed(2));
      } catch (error) {
        console.error("Error fetching vesting data:", error.message || error);
        setError(error.message || "Failed to fetch vesting data.");
      }
    };
  
    fetchVestingData();
  }, [address, isConnected]);
  

    const [maxBalance, setMaxBalance] = useState(null);
    const [balance, setBalance] = useState(0);

useEffect(() => {
  let intervalId;

  const _balance = async () => {
    const _myBalance = await myTokenBalance();
    console.log(_myBalance);
    setBalance(_myBalance);

    const _maxBalance = await maxBalances();
    console.log(_maxBalance);
    setMaxBalance(_maxBalance);
  };

  if (address) {
    _balance(); // run immediately

    intervalId = setInterval(() => {
      _balance(); // refresh every 10s
    }, 10000);
  }

  return () => {
    if (intervalId) clearInterval(intervalId); // cleanup on unmount or address change
  };
}, [address]);



const handleVestClaimTokens = async () => {
    const networks = {
    ETH: { id: 1, name: "Ethereum Mainnet" },
  };
  try {
    setVestLoading(true);
if (chainId !== networks.ETH.id) {
              switchNetwork(mainnet);
              console.log("🔁 Switching to Ethereum Mainnet...");
            }
    await claimvestTokens(); // your claim logic
    toast.success("Claim successful");
    window.location.reload();

  } catch (err) {
    console.error("⛔ Vest Claim Error (Full):", err);

    const rawMessage =
      err?.reason ||
      err?.error?.message ||
      err?.data?.message ||
      err?.message ||
      "Unknown error";

    // Default:
    let userMessage = "Claim failed";

    // Show specific messages only if small and user-friendly
    if (/user rejected/i.test(rawMessage)) {
      userMessage = "Transaction rejected by user.";
    } else if (/insufficient funds/i.test(rawMessage)) {
      userMessage = "Not enough gas to complete transaction.";
    } else if (/execution reverted/i.test(rawMessage)) {
      userMessage = "Claim failed. Vesting not available yet.";
    } else if (/network error/i.test(rawMessage)) {
      userMessage = "Network error. Please try again.";
    } else if (/timeout/i.test(rawMessage)) {
      userMessage = "Request timed out.";
    } else {
      // If the message is long/complex, just use generic fallback
      const plain = rawMessage.toString().trim();
      userMessage = plain.length > 80 ? "Claim failed." : plain;
    }

    toast.error(userMessage);
  } finally {
    setVestLoading(false);
  }
};


  const { chainId, switchNetwork } = useAppKitNetwork();



const formatCompactNumber = (num) => {
  const number = typeof num === "string" ? parseFloat(num) : num;
  if (isNaN(number)) return "0";
  if (number >= 1_000_000_000_000) return (number / 1_000_000_000_000).toFixed(2) + "T";
  if (number >= 1_000_000_000) return (number / 1_000_000_000).toFixed(2) + "B";
  if (number >= 1_000_000) return (number / 1_000_000).toFixed(2) + "M";
  if (number >= 1_000) return (number / 1_000).toFixed(2) + "K";
  return number.toFixed(2);
};

const [vestAmount, setVestAmount] = useState("");
const [hVestLoading, setHVestLoading] = useState(false);
const [vestTxHash, setVestTxHash] = useState("");



// inside the VestingPage component:
const { approveTokens, checkAllowance } = useContract();
const [isApproved, setIsApproved] = useState(false);
const [approvalLoading, setApprovalLoading] = useState(false);


// When the amount/address/network changes, check if already approved
const [checkingAllowance, setCheckingAllowance] = useState(false);
useEffect(() => {
  let mounted = true;
  async function check() {
    if (!address) {
      setIsApproved(false);
      return;
    }
    
    // If vestAmount is empty or zero, show Vest Now by forcing isApproved to true
    if (!vestAmount || Number(vestAmount) <= 0) {
      setIsApproved(true);  // Show Vest Now initially or when no amount entered
      return;
    }

    setCheckingAllowance(true);
    try {
      const allowed = await checkAllowance(address, vestAmount);
      if (mounted) setIsApproved(allowed);
    } catch (e) {
      if (mounted) setIsApproved(false);
    }
    setCheckingAllowance(false);
  }
  check();
  return () => { mounted = false };
}, [address, vestAmount, isConnected]);



const handleApprove = async () => {
  setApprovalLoading(true);
  const networks = {
    ETH: { id: 1, name: "Ethereum Mainnet" },
  };
  try {
   if (chainId !== networks.ETH.id) {
              switchNetwork(mainnet);
              console.log("🔁 Switching to Ethereum Mainnet...");
            }

    const amount = vestAmount?.toString().trim();
    if (!amount || parseFloat(amount) <= 0) {
      toast.error("Please enter a valid vest amount.");
      setApprovalLoading(false);
      return;
    }

    await approveTokens(amount);
    setIsApproved(true);
    toast.success("Approval successful!");
  } catch (e) {
    console.error("Approve error:", e);
    if (/user rejected/i.test(e?.message)) {
      toast.error("Transaction rejected by user.");
    } else if (/insufficient funds/i.test(e?.message)) {
      toast.error("Not enough gas to approve.");
    } else {
      toast.error("Approval failed!");
    }
  } finally {
    setApprovalLoading(false);
  }
};


const handleVest = async () => {

            
  const toastId = toast.loading("Processing your vest...");
  setHVestLoading(true);

  try {          const networks = {
      ETH: { id: 1, name: "Ethereum Mainnet" },
    };
        

          if (chainId !== networks.ETH.id) {
              switchNetwork(mainnet);
              console.log("🔁 Switching to Ethereum Mainnet...");
            }
    if (!vestAmount || parseFloat(vestAmount) <= 0) {
      toast.dismiss(toastId);
      toast.error("Please enter a valid vest amount.");
      setHVestLoading(false);
      return;
    }

    const txReceipt = await manualvestTokens(vestAmount); // Your vest function
    if (!txReceipt) throw new Error("Transaction failed");

    setVestTxHash(txReceipt.transactionHash);
    setVestAmount("");

    toast.dismiss(toastId);
    toast.success("Vesting successful!");

    setTimeout(() => {
      window.location.reload();
    }, 1200);
  } catch (err) {
    console.error("Vest failed:", err);
    toast.dismiss(toastId);
    toast.error("Vesting failed");
  } finally {
    setHVestLoading(false);
  }
};


useEffect(() => {
  if (!address || !isConnected) return;

  const run = async () => {
    try {
      const allocation = await getVestedAllocation();
      const claimed = await getVestedClaimed();
      const claimable = await getVestedClaimable();

      const formattedAllocation = parseFloat(allocation || "0");
      const formattedClaimed = parseFloat(claimed || "0");
      const formattedClaimable = parseFloat(claimable || "0");
      const locked = Math.max(
        0,
        formattedAllocation - formattedClaimable - formattedClaimed
      );

      await saveVestingData({
        address,
        vestedAllocated: formattedAllocation,
        vestedClaimed: formattedClaimed,
        vestedClaimable: formattedClaimable,
        vestedLocked: locked,
      });

    } catch (err) {
      console.error("Error fetching vesting data:", err);
    }
  };

  run();
}, [address, isConnected]);


  return (
<div className="relative w-full  overflow-hidden bg-transparent">
      {/* 🔆 LEFT GLOW */}

     <section className=" py-15 px-8 max-md:py-16 max-md:px-4">
      <div className="max-w-[1440px] mx-auto flex items-center justify-between gap-16 max-md:flex-col-reverse">
        {/* Left Side */}
        <div className="w-1/2 max-md:w-full">
    
          <h1 className="text-[58px] font-extrabold text-white leading-[1.2] max-md:text-4xl max-md:leading-snug font-fredoka">
         Vesting Schedule   <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF]">
       
            </span><br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF]">
         – Building Trust, One Block at a Time
            </span>
          </h1>

          <p className="mt-8 text-xl text-white max-w-xl leading-relaxed max-md:text-base max-md:mt-4">
      Transparency is magical! Baby Unicorn AI is committed to long-term sustainability and fairness. That’s why our token release is carefully structured to protect the community and ensure responsible growth.
          </p>


        </div>

        {/* Right Side Unicorn Image */}
        <div className="w-1/2 flex justify-center max-md:w-full">
          <img
            src="Group2.png"
            alt="Baby Unicorn"
            className="max-w-[520px] w-full"
          />
        </div>
      </div>

      









    </section>

<div
  className="flex flex-col max-w-[1343px] mx-auto max-md:mx-4 items-start gap-10 p-[42px] max-md:p-4 relative bg-[#2a2540] rounded-3xl"
  data-model-id="12:4128"
>
<div className="flex w-full items-center gap-4 relative flex-[0_0_auto] max-md:flex-col max-md:items-start">
  {/* Title */}
  <div className="text-white text-[32px] font-semibold [font-family:'Inter',Helvetica]">
    Vesting Summary
  </div>

  {/* Divider Line */}
  <div className="w-px h-6 bg-white opacity-30 max-md:hidden" />

  {/* Wallet Balance */}
  {balance !== null && (
    <div className="text-white text-lg font-medium bg-[#3a3350] px-4 py-1 rounded-full">
     Wallet Balance {formatCompactNumber(balance)} BABYU
    </div>
  )}
</div>


  <div className="flex items-center justify-between relative self-stretch w-full flex-wrap max-md:flex-col max-md:items-start max-md:gap-6 flex-[0_0_auto]">
    <div className="inline-flex flex-col items-start gap-3 relative flex-[0_0_auto]">
      <div className="relative w-fit mt-[-1.00px] [font-family:'Inter',Helvetica] font-normal text-[#bebebe] text-xl tracking-[0] leading-[normal] whitespace-nowrap">
        Wallet
      </div>
      <div className="relative w-fit [font-family:'Inter',Helvetica] font-semibold text-neutral-100 text-2xl tracking-[0] leading-[normal]">
       {isConnected
            ? `${address?.substring(0, 4)}...${address?.slice(-4)}`
            : "Connect Wallet"}
      </div>
    </div>

    <img
      className="relative w-px h-[23px] object-cover max-md:hidden"
      alt="Line"
      src="https://c.animaapp.com/mckocw1j033gK7/img/line-37.svg"
    />

    <div className="inline-flex flex-col items-start gap-3 relative flex-[0_0_auto]">
      <div className="relative w-fit mt-[-1.00px] [font-family:'Inter',Helvetica] font-normal text-[#bebebe] text-xl tracking-[0] leading-[normal] whitespace-nowrap">
       Total Allocated
      </div>
      <div className="relative w-fit [font-family:'Inter',Helvetica] font-semibold text-neutral-100 text-2xl tracking-[0] leading-[normal]">
       {Number(totalVestedTokens).toFixed(0)} BABYU
      </div>
    </div>

    <img
      className="relative w-px h-[23px] object-cover max-md:hidden"
      alt="Line"
      src="https://c.animaapp.com/mckocw1j033gK7/img/line-37.svg"
    />

    <div className="inline-flex flex-col items-start gap-3 relative flex-[0_0_auto]">
      <div className="relative w-fit mt-[-1.00px] [font-family:'Inter',Helvetica] font-normal text-[#bebebe] text-xl tracking-[0] leading-[normal] whitespace-nowrap">
        Available
      </div>
      <div className="relative w-fit [font-family:'Inter',Helvetica] font-semibold text-neutral-100 text-2xl tracking-[0] leading-[normal]">
        {Number(totalVestedClaimableTokens).toFixed(0)} BABYU
      </div>
    </div>

    <img
      className="relative w-px h-[23px] object-cover max-md:hidden"
      alt="Line"
      src="https://c.animaapp.com/mckocw1j033gK7/img/line-37.svg"
    />

    <div className="inline-flex flex-col items-start gap-3 relative flex-[0_0_auto]">
      <div className="relative w-fit mt-[-1.00px] [font-family:'Inter',Helvetica] font-normal text-[#bebebe] text-xl tracking-[0] leading-[normal] whitespace-nowrap">
        Total Claimed
      </div>
      <div className="relative w-fit [font-family:'Inter',Helvetica] font-semibold text-neutral-100 text-2xl tracking-[0] leading-[normal]">
       {Number(totalVestedClaimedTokens).toFixed(0)} BABYU
      </div>
    </div>

    <img
      className="relative w-px h-[23px] object-cover max-md:hidden"
      alt="Line"
      src="https://c.animaapp.com/mckocw1j033gK7/img/line-37.svg"
    />

    <div className="inline-flex flex-col items-start gap-3 relative flex-[0_0_auto]">
      <div className="relative w-fit mt-[-1.00px] [font-family:'Inter',Helvetica] font-normal text-[#bebebe] text-xl tracking-[0] leading-[normal] whitespace-nowrap">
        Locked
      </div>
      <div className="relative w-fit [font-family:'Inter',Helvetica] font-semibold text-neutral-100 text-2xl tracking-[0] leading-[normal]">
{Math.max(0, Number(totalVestedTokens - totalVestedClaimableTokens - totalVestedClaimedTokens)).toFixed(0)} BABYU

      </div>
    </div>
  </div>

<div className="w-full mt-10 flex justify-center px-4">
  <div className="flex flex-wrap md:flex-nowrap flex-col md:flex-row items-center gap-4 w-full max-w-[900px] justify-center">
    
    {/* Bigger Vest Amount Input */}
 <input
  type="number"
  placeholder="Enter amount to vest"
  value={vestAmount}
  onChange={(e) => setVestAmount(e.target.value)}
  className="h-[60px] w-full md:max-w-[300px] px-6 py-3 rounded-full border border-white text-white bg-[#1e1b33] text-xl outline-none"
/>


    {/* Vest Now Button */}
{/* In your render/return block */}

{!isConnected ? (
  // Before wallet connected: optionally show a button or prompt to connect wallet
  <button
    onClick={() => open("connect")}
    className="h-[60px] w-full md:max-w-[300px] px-6 py-3 rounded-full text-white font-semibold text-[18px] border-2 border-white shadow-[0px_4px_16px_#ff49b8] bg-gradient-to-r from-pink-400 via-purple-400 to-sky-400"
  >
     Vest Now
  </button>
) : !vestAmount ? (
  // Wallet connected but empty vest amount, show disabled "Vest Now"
  <button
    disabled
    className="h-[60px] w-full md:max-w-[300px] px-6 py-3 rounded-full opacity-50 cursor-not-allowed text-white font-semibold text-[18px] border-2 border-white shadow-[0px_4px_16px_#49b8ff] bg-[linear-gradient(90deg,rgba(107,201,255,1)_0%,rgba(170,129,255,1)_47%,rgba(255,110,179,1)_100%)]"
  >
    Vest Now
  </button>
) : !isApproved ? (
  // Wallet connected, vestAmount entered, not approved => Approve button enabled
  <button
    onClick={handleApprove}
    disabled={approvalLoading}
    className="h-[60px] w-full md:max-w-[300px] px-6 py-3 rounded-full text-white font-semibold text-[18px] border-2 border-white shadow-[0px_4px_16px_#ff49b8] bg-[linear-gradient(90deg,rgba(255,110,179,1)_0%,rgba(170,129,255,1)_47%,rgba(107,201,255,1)_100%)]"
  >
    {approvalLoading ? "Approving..." : "Approve"}
  </button>
) : (
  // Wallet connected, vestAmount entered, approved => Vest Now button
  <button
    onClick={handleVest}
    disabled={hVestLoading}
    className="h-[60px] w-full md:max-w-[300px] px-6 py-3 rounded-full text-white font-semibold text-[18px] border-2 border-white shadow-[0px_4px_16px_#49b8ff] bg-[linear-gradient(90deg,rgba(107,201,255,1)_0%,rgba(170,129,255,1)_47%,rgba(255,110,179,1)_100%)]"
  >
    {hVestLoading ? "Vesting..." : "Vest Now"}
  </button>
)}


    {/* Claim All Available Button */}
    <button
      className={`h-[60px] w-full md:max-w-[300px] px-6 py-3 rounded-full text-white font-semibold text-[18px] border-2 border-white shadow-[0px_4px_16px_#ff49b8] bg-[linear-gradient(90deg,rgba(255,110,179,1)_0%,rgba(170,129,255,1)_47%,rgba(107,201,255,1)_100%)] ${
        vestLoading ? "opacity-70 cursor-not-allowed" : ""
      }`}
      onClick={vestLoading ? () => {} : handleVestClaimTokens}
      disabled={vestLoading}
    >
      {vestLoading ? (
        <ClipLoader
          color={color}
          loading={vestLoading}
          cssOverride={override}
          size={20}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      ) : (
        <span>Claim All Available</span>
      )}
    </button>
  </div>
</div>





</div>













<VestOverview/>





<VestWorks/>












 <FAQSection/>
        <Footer />

    </div>
  );
};

export default VestingPage;
